import { useStore } from '@/store';

export const useNavigateAway = () => {
  const setNavDomainOpen = useStore(
    ({ config }) => config.setisNavDomainModalOpen,
  );
  const setNavTemplateOpen = useStore(
    ({ config }) => config.setIsNavTemplateModalOpen,
  );

  const requestNavigateToDomain = () => {
    setNavDomainOpen(true);
  };

  const requestNavigateToTemplate = () => {
    setNavTemplateOpen(true);
  };

  return {
    requestNavigateToDomain,
    requestNavigateToTemplate,
  };
};
